import React from "react";
import { IconButton } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";

const IconButtonCell: React.FC<{
  icon: SvgIconComponent;
  hoverColorClass: string;
  onClick: any;
}> = React.memo(({ icon: Icon, hoverColorClass, onClick }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <IconButton onClick={onClick}>
        {<Icon className={`pulse-color--background-50 ${hoverColorClass}`} />}
      </IconButton>
    </div>
  );
});

export default IconButtonCell;
